<template>
    <div class="box_M">
        <div class="info_box_m">
            <div class="title">用户查询</div>
            <van-form @submit="onSubmit" ref="form" class="login_form_m">

                <van-field v-model="form.mobile" label="手机号" maxlength="11" name="mobile" autocomplete="off"
                :rules="[
                    { required: true, message: '请填写您的手机号码' },
                    { pattern: /^1\d{10}$/, message: '手机号码格式错误'}
                ]" />

                <!-- 验证码 -->
                <van-cell class="code_box">
                        <van-field v-model="form.code" label="验证码" :rules="[{ required: true, message: `请输入验证码` }]" />
                        <!-- 因为获取不到验证码，所以暂时注释，后期有可能恢复 -->
                        
                        <div class="getCode" v-show="!showVerCode" @click="showVerCoding">获取验证码</div>
                        <van-count-down v-show="showVerCode" :time="60000" :auto-start="false" format="ss秒后重新获取" ref="countdown" @finish="finish" />
                       
                        <!-- <div class="getCode" @click="showWarning">获取验证码</div> -->
                </van-cell>

                <van-button round block type="info" native-type="submit">提交</van-button>
            </van-form>
        </div>

        <bottom-menu></bottom-menu>
    </div>
</template>

<script>
import BottomMenu from '@/components/mobile/BottomMenu.vue'
import { getSmsCode,smsLogin,getUserInfo } from '@/service/api.js'
import {encrypt} from "../../../utils/jsencrypt";

export default {
    components: { BottomMenu },
    data() {
        return {
            showVerCode:false,
            form:{
                code:'',
                mobile:''
            },
        }
    },
    methods: {
        // 提示系统正在升级中
        showWarning(){
            this.$toast('请输入验证码')
        },
        showVerCoding(){
            this.$refs.form.validate('mobile').then(() => {
                this.showVerCode = true
                this.$refs.countdown.start()
                getSmsCode({mobile:encrypt(''+this.form.mobile)}).then(data=>{
                    if (data.code!==0) {
                        this.$toast(data.msg)
                    }else{
                        console.log(data);
                    }
                })
            }).catch(() => {
                this.$toast('请填写正确的手机号')
            })
        },
        finish(){
            this.showVerCode = false
            this.$refs.countdown.reset()
        },
        onSubmit() {
            this.$refs.form.validate().then(() => {
                smsLogin(this.form).then(data=>{
                    // console.log(data);
                    if (data.code !==0) {
                        this.$toast(data.msg)
                    }else {
                        if (data.token) {
                            localStorage.setItem('token',data.token)
                            getUserInfo().then(data=>{
                                console.log(data);
                                if (data.code !== 0 ) {
                                    this.$toast(data.msg)
                                }else{
                                    this.$store.commit('setUserInfo',data.data)
                                }
                                // 登陆后跳转页面
                                if (localStorage.getItem('fromUrlName')) {
                                    console.log(localStorage.getItem('fromUrlName'));
                                    this.$router.push({path:localStorage.getItem('fromUrlName')})
                                }else{
                                    this.$router.push({name:'M_My'})
                                }
                            })
                        }
                        console.log(this.$store.state.userInfo);
                    }
                })
            }).catch(() => {
                this.$toast('提交失败')
            })
        },
    },
}
</script>

<style>

</style>
